import { useState } from "react";
import { Lock, LogIn } from "lucide-react";
import { LoginDialog } from "../components/LoginDialog";

/** Platzhalter für eine Seite, die eine Anmeldung braucht.
 *
 *  Zeigt bewusst nichts über den Inhalt — nur, dass es ihn gibt, und den Weg
 *  hinein. Die Adresse bleibt dabei stehen, sodass nach dem Anmelden genau
 *  diese Seite erscheint. */
export function LockedPage() {
  const [open, setOpen] = useState(false);
  return (
    <div className="page locked-page">
      <div className="locked-card">
        <Lock className="icon-svg locked-icon" />
        <h1>Sign in required</h1>
        <button className="locked-btn" onClick={() => setOpen(true)}>
          <LogIn className="icon-svg" /> Sign in
        </button>
      </div>
      <LoginDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
